import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  loadingText: {
    defaultValue: 'Os nichos estão sendo gerados gradualmente. Você pode explorar o que já está visível enquanto isso.',
    key: 'NicheTab-loadingText',
  },
  generatingText: {
    defaultValue: 'Os nichos estão sendo gerados gradualmente...',
    key: 'NicheTab-generatingText',
  },
  reportButton: {
    defaultValue: 'Criar report',
    key: 'NicheTab-reportButton',
  },
  happeningNowAlert: ({ nicheLimit }) => ({
    key: 'NicheTab-happeningNowAlert',
    parameters: {
      nicheLimit,
    },
    defaultValue:
      'A listagem de nichos deste contexto é atualizada diariamente com até {nicheLimit} nichos mais engajados.',
  }),
})
